import { OutgoingOrderContent, OutgoingTransactionOrder } from '@ui/src';
import { useAppSelector } from '@store';

const ProblemOutgoingOrderContentHOC = (): React.JSX.Element => {
  const { transaction } = useAppSelector(
    (state) => state.customersProblemTransactions.outgoing,
  );

  return (
    <OutgoingOrderContent
      isLoading={false}
      order={transaction as OutgoingTransactionOrder}
      paymentType={transaction?.paymentType}
      setChangedPaymentType={() => {}}
      setChangedPaymentTypeHintVisible={() => {}}
    />
  );
};

export default ProblemOutgoingOrderContentHOC;
